// uat：wwc20795e2b3f16505
// stg：wwc20795e2b3f16505
// stg2：wwc20795e2b3f16505
// prd：wxead7ba7c61cc5a8f

let baseUrl = 'https://loginuat.countrygarden.com.cn:8443', redirectUri= 'http://localhost:6003', clientId = 'sguat'; 

let env = process.env.VUE_APP_CURRENTMODE
// let protocol = 'https:'
let protocol = 'https:'
// let protocol = top.location.protocol
switch(env){

    case 'dev':
        baseUrl = `https://loginuat.countrygarden.com.cn:8443`
        redirectUri = `${protocol}//bgy.dev.rscloud.com/`
        clientId = 'sguat';
        break;
    case 'uat1':
        baseUrl = `http://ssotest.sce-re.com`
        redirectUri = `${protocol}//bgy.dev.rscloud.com/`
        clientId = 'czHN8vfGkc';
        break;  
    case 'stg':
        baseUrl = `https://loginuat.countrygarden.com.cn:8443`
        redirectUri = `${protocol}//sguat.cgcctg.com/`
        clientId = 'sguat';
        break;  
    case 'prd':
        baseUrl = `https://login.countrygarden.com.cn`
        redirectUri = `${protocol}//sg.cgcctg.com/`
        clientId = 'sg';
        break;
}
let redirect = {baseUrl, redirectUri, clientId}
export default redirect
